import SisDkpClienteClient from '@/api/sis-dkp-cliente.client';

const sisDkpClientesClient = new SisDkpClienteClient();
export default {
  namespaced: true,
  state: () => ({
    copy_dkp_cliente: null,
    dkp_cliente: {
      id: null,
      nome_fantasia: null,
      razao_social: null,
      cnpj: null,
      subdominio: null,
      status: 1,
    },
    dkp_clientes_all: [],
    filters: {
      page: 1,
      perPage: 10,
      sortBy: 'id',
      sortDesc: null,
      total: 0,
    },
    optionsMarcas: [],
    optionsReferencias: [],
    optionsEmbalagens: [],
    isLoading: false,
  }),
  mutations: {
    SET_DKP_CLIENTES_ALL(state, payload) {
      state.dkp_clientes_all = payload;
    },
    SET_DKP_CLIENTE(state, payload) {
      state.dkp_cliente = payload;
    },
    SET_COPY_DKP_CLIENTE(state, payload) {
      state.copy_dkp_cliente = payload;
    },
    SET_FILTERS(state, payload) {
      state.filters = payload;
    },
  },
  getters: {
    GET_DKP_CLIENTES_ALL(state) {
      return state.dkp_clientes_all;
    },
    GET_DKP_CLIENTE(state) {
      return state.dkp_cliente;
    },
    GET_COPY_DKP_CLIENTE(state) {
      return state.copy_dkp_cliente;
    },
    GET_FILTERS(state) {
      return state.filters;
    },
  },
  actions: {
    RESERT_DKP_CLIENTE(ctx) {
      ctx.commit('SET_DKP_CLIENTE', {
        id: null,
        nome_fantasia: null,
        razao_social: null,
        cnpj: null,
        subdominio: null,
        status: 1,
      });
    },
    async findAll(ctx, queryParams, options) {
      const { data, ...paginations } = await sisDkpClientesClient.getDkpClientes(queryParams);
      ctx.commit('SET_DKP_CLIENTES_ALL', data);
      ctx.commit('SET_FILTERS', {
        ...ctx.getters.GET_FILTERS,
        ...paginations,
      });
      return Promise.resolve({
        data,
        paginations,
      });
    },
  },
};
